module.exports = __webpack_public_path__ + "static/media/DrugBox.3bf858b5.svg";